var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumber3Red(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D52B1E;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72,
    cy: 72,
    r: 72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,93.6L59,89.3c1.6,3,4.4,8.2,12.3,8.2s12.5-4.7,12.5-11.4S79,74.5,66.5,74.5h-4.8V61.6h4.8 c10.8,0,15.8-3.9,15.8-10.3c0-5.4-4.5-9.7-11.1-9.7c-4.5,0-9.4,1.8-11.7,7.9l-14.2-4.2C48.5,34.1,59.7,28,71.7,28 C86.5,28,98,37,98,49.9c0,8.4-5.3,14.4-12.9,17.9c8.7,4,14.5,11,14.5,20.1c0,14.6-12.9,23.2-27.2,23.2S47.4,104.3,44.5,93.6 L44.5,93.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3Red);
export default __webpack_public_path__ + "static/media/Number-3-Red.59bdd1f8526275ab86906d12fea81f56.svg";
export { ForwardRef as ReactComponent };